import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ImageModule } from '@df/module-image/image.module';
import { KlevuSearchService } from '@df/module-klevu-search/klevu-search.service';
import { OffClickModule } from '@df/module-off-click/off-click.module';
import { SearchOutletComponentDef } from '@df/search/search-outlet.component.def';
import { CarouselModule } from '@df/ui-carousel/carousel.module';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ProductComponent } from '../../catalog/product/product/product.component';
import { IOffCanvasSearchTrayModalBlockDataContent } from './off-canvas-search-tray-modal.component';
import { SearchBannerComponent } from './search-banner.component';
import { SearchLinksComponent } from './search-links.component';
@Component({
    selector: 'open-search-outlet',
    templateUrl: './open-search-outlet.component.html',
    standalone: true,
    imports: [
        SearchBannerComponent,
        SearchLinksComponent,
        CommonModule,
        OffClickModule,
        ProductComponent,
        GridModule,
        ProductComponent,
        TranslationModule,
        RouterLink,
        ImageModule,
        CarouselModule
    ]
})
export class OpenSearchOutletComponent extends SearchOutletComponentDef {
    @Input()
    contentBlockData?: IOffCanvasSearchTrayModalBlockDataContent;

    get popularTerms() {
        return (this.searchService as KlevuSearchService).webstorePopularTerms;
    }
}
